import { render, staticRenderFns } from "./ChatGroupSide.vue?vue&type=template&id=0755349b"
import script from "./ChatGroupSide.vue?vue&type=script&lang=js"
export * from "./ChatGroupSide.vue?vue&type=script&lang=js"
import style0 from "./ChatGroupSide.vue?vue&type=style&index=0&id=0755349b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports